
import React from 'react';
import StatsCard from './StatsCard';
import SimpleCardStatsCard from './SimpleCardStatsCard';

interface StatsSectionsProps {
  matchResults: any;
  foulsStats: any;
  htFtStats: any;
  overUnderStats: any[];
  overUnderHomeStats: any[];
  overUnderAwayStats: any[];
  overUnderHtStats: any[];
  overUnderHtHomeStats: any[];
  overUnderHtAwayStats: any[];
  overallGoalsStats: any;
  homeGoalsStats: any;
  awayGoalsStats: any;
  overallCardStats: any;
  homeCardStats: any;
  awayCardStats: any;
  overallCornerStats: any;
  homeCornerStats: any;
  awayCornerStats: any;
}

export const StatsSections: React.FC<StatsSectionsProps> = ({
  matchResults,
  foulsStats,
  htFtStats,
  overUnderStats,
  overUnderHomeStats,
  overUnderAwayStats,
  overUnderHtStats,
  overUnderHtHomeStats,
  overUnderHtAwayStats,
  overallGoalsStats,
  homeGoalsStats,
  awayGoalsStats,
  overallCardStats,
  homeCardStats,
  awayCardStats,
  overallCornerStats,
  homeCornerStats,
  awayCornerStats,
}) => {
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-3 gap-4">
        <StatsCard 
          title="HT Win Stats" 
          stats={[
            { threshold: 1, overPercentage: htFtStats.htWinFtWin || '0' },
            { threshold: 2, overPercentage: htFtStats.htWinFtDraw || '0' },
            { threshold: 3, overPercentage: htFtStats.htWinFtLose || '0' }
          ]}
          color="bg-indigo-500"
          customLabels={[
            "HT Win/FT Win",
            "HT Win/FT Draw",
            "HT Win/FT Lose"
          ]}
        />
        <StatsCard 
          title="HT Draw Stats" 
          stats={[
            { threshold: 4, overPercentage: htFtStats.htDrawFtWin || '0' },
            { threshold: 5, overPercentage: htFtStats.htDrawFtDraw || '0' },
            { threshold: 6, overPercentage: htFtStats.htDrawFtLose || '0' }
          ]}
          color="bg-indigo-500"
          customLabels={[
            "HT Draw/FT Win",
            "HT Draw/FT Draw",
            "HT Draw/FT Lose"
          ]}
        />
        <StatsCard 
          title="HT Lose Stats" 
          stats={[
            { threshold: 7, overPercentage: htFtStats.htLoseFtWin || '0' },
            { threshold: 8, overPercentage: htFtStats.htLoseFtDraw || '0' },
            { threshold: 9, overPercentage: htFtStats.htLoseFtLose || '0' }
          ]}
          color="bg-indigo-500"
          customLabels={[
            "HT Lose/FT Win",
            "HT Lose/FT Draw",
            "HT Lose/FT Lose"
          ]}
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <StatsCard 
          title="Goals" 
          stats={overUnderStats.map(({ threshold, overPercentage }) => ({
            threshold: parseFloat(threshold.toString()),
            overPercentage: overPercentage?.toString() || '0'
          }))}
          color="bg-pink-500"
          total={overallGoalsStats.totalGoals}
          average={overallGoalsStats.average}
          most={overallGoalsStats.mostGoals}
          least={overallGoalsStats.leastGoals}
        />
        <StatsCard 
          title="Goals (Home)" 
          stats={overUnderHomeStats.map(({ threshold, overPercentage }) => ({
            threshold: parseFloat(threshold.toString()),
            overPercentage: overPercentage?.toString() || '0'
          }))}
          color="bg-pink-400"
          total={homeGoalsStats.totalGoals}
          average={homeGoalsStats.average}
          most={homeGoalsStats.mostGoals}
          least={homeGoalsStats.leastGoals}
        />
        <StatsCard 
          title="Goals (Away)" 
          stats={overUnderAwayStats.map(({ threshold, overPercentage }) => ({
            threshold: parseFloat(threshold.toString()),
            overPercentage: overPercentage?.toString() || '0'
          }))}
          color="bg-pink-300"
          total={awayGoalsStats.totalGoals}
          average={awayGoalsStats.average}
          most={awayGoalsStats.mostGoals}
          least={awayGoalsStats.leastGoals}
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <StatsCard 
          title="HT Goals" 
          stats={overUnderHtStats.map(({ threshold, overPercentage }) => ({ threshold, overPercentage: overPercentage || '0' }))}
          color="bg-orange-500"
          total={overallGoalsStats.totalGoals}
          average={overallGoalsStats.average}
          most={overallGoalsStats.mostGoals}
          least={overallGoalsStats.leastGoals}
        />
        <StatsCard 
          title="HT Goals (Home)" 
          stats={overUnderHtHomeStats.map(({ threshold, overPercentage }) => ({ threshold, overPercentage: overPercentage || '0' }))}
          color="bg-orange-400"
          total={homeGoalsStats.totalGoals}
          average={homeGoalsStats.average}
          most={homeGoalsStats.mostGoals}
          least={homeGoalsStats.leastGoals}
        />
        <StatsCard 
          title="HT Goals (Away)" 
          stats={overUnderHtAwayStats.map(({ threshold, overPercentage }) => ({ threshold, overPercentage: overPercentage || '0' }))}
          color="bg-orange-300"
          total={awayGoalsStats.totalGoals}
          average={awayGoalsStats.average}
          most={awayGoalsStats.mostGoals}
          least={awayGoalsStats.leastGoals}
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <SimpleCardStatsCard
          title="Cards Overall"
          {...overallCardStats}
        />
        <SimpleCardStatsCard
          title="Cards Home"
          {...homeCardStats}
        />
        <SimpleCardStatsCard
          title="Cards Away"
          {...awayCardStats}
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <StatsCard 
          title="Corners" 
          stats={overallCornerStats.overUnderStats.map(stat => ({
            threshold: stat.threshold,
            overPercentage: stat.overPercentage || '0'
          }))}
          color="bg-cyan-500"
          total={overallCornerStats.totalCorners}
          average={overallCornerStats.average}
          most={overallCornerStats.most}
          least={overallCornerStats.least}
        />
        <StatsCard 
          title="Corners (Home)" 
          stats={homeCornerStats.overUnderStats.map(stat => ({
            threshold: stat.threshold,
            overPercentage: stat.overPercentage || '0'
          }))}
          color="bg-cyan-400"
          total={homeCornerStats.totalCorners}
          average={homeCornerStats.average}
          most={homeCornerStats.most}
          least={homeCornerStats.least}
        />
        <StatsCard 
          title="Corners (Away)" 
          stats={awayCornerStats.overUnderStats.map(stat => ({
            threshold: stat.threshold,
            overPercentage: stat.overPercentage || '0'
          }))}
          color="bg-cyan-300"
          total={awayCornerStats.totalCorners}
          average={awayCornerStats.average}
          most={awayCornerStats.most}
          least={awayCornerStats.least}
        />
      </div>
    </div>
  );
};
